import { render, staticRenderFns } from "./forfait.vue?vue&type=template&id=0b2ce5a3&scoped=true"
import script from "./forfait.vue?vue&type=script&lang=js"
export * from "./forfait.vue?vue&type=script&lang=js"
import style0 from "./forfait.vue?vue&type=style&index=0&id=0b2ce5a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ce5a3",
  null
  
)

export default component.exports